import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { marquee as MarqueePropType } from 'lib/CustomPropTypes';
import { dismissMarquee as dismissMarqueeAction } from 'redux/modules/marquee';

import { Breaking } from './Breaking';
import { Embed } from './Embed';

function Marquee({
  dismissMarquee,
  isShellArticle,
  marquees,
  vertical,
}) {
  // Hide on shell articles
  if (isShellArticle) {
    return null;
  }
  return (
    <>
      {marquees.map((marquee, index) => {
        const { marqueeType: type } = marquee;
        const key = `marquee-${index}`;
        // Embed marquee
        if (type === 'embed') {
          return (
            <Embed
              key={key}
              index={index}
              marquee={marquee}
            />
          );
        }
        // breakingNews, callOut, etc marquee
        if (type !== 'embed' && vertical !== 'knowyourvalue') {
          return (
            <Breaking
              key={key}
              marquee={marquee}
              dismissMarquee={dismissMarquee}
            />
          );
        }
        // Unsupported type?
        return null;
      })}
    </>
  );
}

Marquee.propTypes = {
  dismissMarquee: PropTypes.func.isRequired,
  isShellArticle: PropTypes.bool.isRequired,
  marquees: PropTypes.arrayOf(MarqueePropType).isRequired,
  vertical: PropTypes.string,
};

Marquee.defaultProps = {
  vertical: null,
};

const mapStoreToProps = ({
  article,
  marquee,
  shared,
}) => ({
  isShellArticle: get(article, 'presentation.style', false) === 'shell',
  marquees: marquee.marquees,
  vertical: shared.vertical,
});

const mapActionsToProps = (dispatch) => ({
  dismissMarquee: () => dispatch(dismissMarqueeAction()),
});

export default React.memo(
  connect(mapStoreToProps, mapActionsToProps)(
    Marquee,
  ),
);
